export default {
  title: "",
  subtitle: "Mexican Companies Registration",
  path: "company_registration_mx",
  paragraphs: [
    "In Mexico the document_type is going to be “rfc” (a 12-digit). Below you can check a payload with initial required information. For other requirements depending on payment methods, check the table in section 'Information needed for registration (Companies)'"
  ],
  request: {
    payload: {
      "company": {
        "document_number": "GUJ970202BG4",
        "document_type": "rfc",
        "social_name": "Company's name",
        "fiscal_country": "Mexico",
      }
    },
    responses: {
      "data": {
        "updated_at": "2024-02-05T22:11:08.714019",
        "status": "approved",
        "social_name": "Company's  name",
        "required_clearance_level": 1,
        "references": [],
        "phone_number": null,
        "partners": [],
        "net_value": null,
        "net_monthly_average_income": null,
        "main_activity": null,
        "inserted_at": "2024-02-05T22:11:08.672280",
        "id": "01cf5b70-569f-43f5-80a4-7af303c9c003",
        "fiscal_country": "Mexico",
        "email": null,
        "documents": [],
        "document_type": "rfc",
        "document_number": "GUJ970202BG4",
        "creation_date": null,
        "company_type": null,
        "company_name": null,
        "clearance_level": 1,
        "address_street": null,
        "address_state": null,
        "address_postal_code": null,
        "address_number": null,
        "address_neighborhood": null,
        "address_country": null,
        "address_complement": null,
        "address_city": null,
        "activity_type": null
      }
    }
  },
  parameterPayload: [
    {
      name: "company",
      type: "object",
      required: true,
      description: "An object containing:",
      is_parent: true
    },{
      name: "company.document_number",
      type: "string",
      required: true,
      description: "Document number",
    },{
      name: "company.document_type",
      type: "string",
      required: true,
      description: "rfc",
    },{
      name: "company.social_name",
      type: "string",
      required: true,
      description: "Company's name",
    },{
      name: "company.fiscal_country",
      type: "string",
      required: true,
      description: "Mexico",
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectCompanies/CompaniesRegistrationMxn.js